import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useNavigate } from 'react-router-dom';

const NavLeft = ({ onToggleSidebar, sidebarOpen, isMobile, projectId, isProjectRoute }) => {
  const navigate = useNavigate();
  return (
    <div className="nav-left">
      {!projectId && (
        <button className="hamburger" onClick={onToggleSidebar}>
          {isMobile ? sidebarOpen ? <CloseIcon /> : <MenuIcon /> : <MenuIcon />}
        </button>
      )}

      {isProjectRoute && projectId && (
        <button
          className="hamburger"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            navigate('/dashboard', { replace: true });
          }}
          onMouseDown={(e) => {
            e.stopPropagation();
          }}
          aria-label="Go to Dashboard">
          <HomeOutlinedIcon />
        </button>
      )}

      <style jsx>{`
        .nav-left {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .hamburger {
          background: transparent;
          border: none;
          cursor: pointer;
          color: var(--gray-darkest);
          display: flex;
          align-items: center;
          justify-content: center;
          pointer-events: auto;
          position: relative;
          z-index: 1101;
          padding: ${isMobile ? '4px' : '8px'};
          transition: background-color 0.2s ease;
        }
        .hamburger:hover {
          background-color: rgba(0, 0, 0, 0.05);
          border-radius: 4px;
        }
        .hamburger:active {
          background-color: rgba(0, 0, 0, 0.1);
        }
      `}</style>
    </div>
  );
};

export default NavLeft;
